module.exports = __webpack_public_path__ + "staticcomp/img/content_1.bf1f406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/6/content_1.jpg
// module id = 5gmz
// module chunks = 39